import { smoothScrollEventListener } from '../utilities/utilities';

export const initSmoothScrollSections = () => {
  smoothScrollEventListener('#description-section-link', 'description-section');
  smoothScrollEventListener('#jobs-section-link', 'jobs-section');
  smoothScrollEventListener('#news-section-link', 'news-section');
  smoothScrollEventListener('#experience-section-link', 'experience-section');
  smoothScrollEventListener('#contact-section-link', 'contact-section');
  smoothScrollEventListener('#offices-section-link', 'offices-section');
};
